import {
  getBudgetEpProjectDepPerfList,
  getBudgetEpProjectPerfAuditList,
  getBudgetEpProjectPerfEvalAuditList,
  getBudgetEpProjectPerfEvalExportDetail,
  getBudgetEpProjectPerfEvalManageList,
  getBudgetEpProjectPerfEvalManagePreFill,
  getBudgetEpProjectPerfMonitorFill,
  getBudgetEpProjectPerfMonitorList,
} from '../services';

export default {
  namespace: 'budgetEpProjectPerf',
  state: {},
  effects: {
    // 项目绩效监控列表查询
    *getBudgetEpProjectPerfMonitorList({ payload }, { call }) {
      return yield call(getBudgetEpProjectPerfMonitorList, payload);
    },
    // 项目绩效监控审核列表查询
    *getBudgetEpProjectPerfAuditList({ payload }, { call }) {
      return yield call(getBudgetEpProjectPerfAuditList, payload);
    },
    // 项目绩效监控填报数据预填充
    *getBudgetEpProjectPerfMonitorFill({ payload }, { call }) {
      return yield call(getBudgetEpProjectPerfMonitorFill, payload);
    },
    // 项目绩效自评列表查询
    *getBudgetEpProjectPerfEvalManageList({ payload }, { call }) {
      return yield call(getBudgetEpProjectPerfEvalManageList, payload);
    },
    // 项目绩效自评审核列表查询
    *getBudgetEpProjectPerfEvalAuditList({ payload }, { call }) {
      return yield call(getBudgetEpProjectPerfEvalAuditList, payload);
    },
    // 项目绩效自评明细导出提交
    *getBudgetEpProjectPerfEvalExportDetail({ payload }, { call }) {
      return yield call(getBudgetEpProjectPerfEvalExportDetail, payload);
    },
    // 项目绩效自评填报数据预填充
    *getBudgetEpProjectPerfEvalManagePreFill({ payload }, { call }) {
      return yield call(getBudgetEpProjectPerfEvalManagePreFill, payload);
    },
    // 部门绩效自评列表查询
    *getBudgetEpProjectDepPerfList({ payload }, { call }) {
      return yield call(getBudgetEpProjectDepPerfList, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
